<style scoped>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.rc_td_bottom {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.rc_td_no_borders {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: none !important;
}

.rc_section {
    padding-top: 12px;
}
.br_rd_odd {
    background-color: rgba(0, 0, 0, .03) !important;
}

tr:hover {
    background-color: transparent !important;
}  

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
    <div class="radius_client">
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">Radius clients</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="show_rad_client_form"
                    color="primary" dark class="mb-2">
                    Add Radius client
            </v-btn>
        </v-toolbar>

        <v-simple-table>
            <template v-slot:default>

<v-dialog v-model="src_ip_dialog" max-width="500px">
    <div>
        <vif_ip_addr_box v-model="show_src_ip_addr_form"
            @canceled="on_src_ip_addr_cancel()"
            @selected="on_src_ip_addr_select($event)">
        </vif_ip_addr_box>
    </div>
    <ValidationObserver ref="src_ip_observer" v-slot="{ invalid }">
    <v-card>
        <v-card-title>
            <span class="headline">Add source IP address. Radius client ID {{ edited_rc.id }}</span>
        </v-card-title>
        <v-card-text>
            <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                            <v-text-field
                                v-model="src_ip"
                                label="Source IP address">
                                <template #append>
                                    <v-btn @click="show_src_ip_addrs_form()">...</v-btn>
                                </template>                          
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </v-col>
                </v-row>  
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close_src_ip_form">
                Cancel</v-btn>
            <v-btn color="blue darken-1" :disabled="invalid" text @click="save_src_ip_form">
                Save</v-btn>
        </v-card-actions>
    </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="rad_client_dialog" max-width="500px">
    <ValidationObserver ref="rad_client_observer" v-slot="{ invalid }">
    <v-card>
        <v-card-title>
            <span class="headline">Add a new radius client</span>
        </v-card-title>
        <v-card-text>
            <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                            <v-text-field
                                v-model="rad_client_id"
                                label="Radius client ID">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider> 
                    </v-col>
                </v-row>  
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close_rad_client_form">
                Cancel</v-btn>
            <v-btn color="blue darken-1" :disabled="invalid" text @click="save_rad_client_form">
                Save</v-btn>
        </v-card-actions>
    </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="rad_server_dialog" max-width="500px">
    <ValidationObserver ref="rad_server_observer" v-slot="{ invalid }">
    <v-card>
        <v-card-title>
            <span class="headline">Add a new {{rad_srv_type}} server. Radius client ID {{ edited_rc.id }}</span>
        </v-card-title>
        <v-card-text>
            <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                            <v-text-field
                                v-model="rad_srv_ip"
                                label="IP address">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="numeric" v-slot="{ errors }">
                            <v-text-field
                                v-model="rad_srv_port"
                                label="Port (optional)">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>                        

                        <ValidationProvider v-slot="{ errors }">
                            <v-text-field
                                v-model="rad_srv_secret"
                                label="Secret (optional)">
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>       
                    </v-col>
                </v-row>  
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="on_rad_server_cancel">
                Cancel</v-btn>
            <v-btn color="blue darken-1" :disabled="invalid" text @click="on_rad_server_save">
                Save</v-btn>
        </v-card-actions>
    </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="dialog" max-width="600px">
    <v-card>
        <v-card-title>
            <span class="headline">Radius client ID {{ edited_rc.id }}</span>
        </v-card-title>

        <v-card-text>
            <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <div class="rc_section">
                            <v-toolbar flat>
                                <v-toolbar-title>Source IP addresses</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn @click="show_src_ip_form()">Add</v-btn>
                            </v-toolbar>
                            <v-data-table
                                    :headers="srcs_headers"
                                    :items="edited_rc.srcs"
                                    sort-by="src"
                                    hide-default-footer
                                    class="elevation-1">

                                <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="srcs_delete_item(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </div>

                        <div class="rc_section">
                            <v-toolbar flat>
                                <v-toolbar-title>Auth servers</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn @click="add_auth_server()">Add</v-btn>
                            </v-toolbar>
                            <v-data-table
                                    :headers="auth_server_headers"
                                    :items="edited_rc.auth_servers"
                                    sort-by="ip"
                                    hide-default-footer
                                    class="elevation-1">
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="del_auth_server(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </div>

                        <div class="rc_section">
                            <v-toolbar flat>
                                <v-toolbar-title>Accounting servers</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn @click="add_acct_server()">Add</v-btn>
                            </v-toolbar>
                            <v-data-table
                                    :headers="acct_server_headers"
                                    :items="edited_rc.acct_servers"
                                    sort-by="ip"
                                    hide-default-footer
                                    class="elevation-1">
                                <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="del_acct_server(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </div>

                        <div class="rc_section">
                            <v-toolbar flat>
                                <v-toolbar-title>Secrets</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn @click="save_secrets()">Save secrets</v-btn>
                            </v-toolbar>
                            <v-text-field
                                v-model="edited_rc.auth_secret"
                                label="Auth sercret">
                            </v-text-field>
                            <v-text-field
                                v-model="edited_rc.acct_secret"
                                label="Accounting sercret">
                            </v-text-field>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Close</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

            <thead>
                <tr>
                    <th class="text-left">
                        Radius client ID 
                    </th>
                    <th class="text-left">
                        Source IP addresses
                    </th>
                    <th class="text-left">
                        Auth servers
                    </th>
                    <th class="text-left">
                        Accounting servers
                    </th>
                    <th class="text-left">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="rc,rc_ind in radius">
                    <tr v-for="(n,ind) in rc.num_rows" :key="rc.id + ':' + n">
                        <td v-if="ind == 0" :class="rad_td_class_w_name('rc_td_bottom', rc_ind)" @dblclick="edit_item(rc)" :rowspan="rc.num_rows">{{ rc.id }}</td>

                        <td :class="rad_td_class(rc, ind, rc_ind)" v-if="rc.srcs[ind] !== undefined" @dblclick="edit_item(rc)">
                            {{ rc.srcs[ind]["src"] }}
                        </td>
                        <td :class="rad_td_class(rc, ind, rc_ind)" @dblclick="edit_item(rc)" v-else></td>

                        <td :class="rad_td_class(rc, ind, rc_ind)" v-if="rc.auth_servers[ind] !== undefined" @dblclick="edit_item(rc)">
                            {{ rc.auth_servers[ind]["ip"] }}:{{ rc.auth_servers[ind]["port"] }}
                        </td>
                        <td :class="rad_td_class(rc, ind, rc_ind)" @dblclick="edit_item(rc)" v-else></td>

                        <td :class="rad_td_class(rc, ind, rc_ind)" v-if="rc.acct_servers[ind] !== undefined" @dblclick="edit_item(rc)">
                            {{ rc.acct_servers[ind]["ip"] }}:{{ rc.acct_servers[ind]["port"] }}
                        </td>
                        <td :class="rad_td_class(rc, ind, rc_ind)" @dblclick="edit_item(rc)" v-else></td>

                        <td v-if="ind == 0" :class="rad_td_class_w_name('rc_td_bottom', rc_ind)" :rowspan="rc.num_rows">
                            <v-icon small class="me-2" @click="edit_item(rc)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="delete_item(rc)">
                                mdi-delete
                            </v-icon>
                        </td>                        
                    </tr>
                </template>
            </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>

import api_client from '../services/api.js';
import vif_ip_addr_box from "../components/vif_ip_addr_box.vue";
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js"

export default {
    name: 'radius_client',
    components: { 
        ValidationProvider, ValidationObserver, vif_ip_addr_box,
    },

    data: () => ({
        edited_rc: {},
        radius: [],
        dialog: false,

        rad_client_id: '',
        rad_client_dialog: false,

        src_ip_dialog: false,
        src_ip: '',
        show_src_ip_addr_form: false,

        deleted_item: {},
        deleted_index: -1,

        rad_srv_type: '',
        rad_srv_ip: '',
        rad_srv_port: 0,
        rad_srv_secret: '',
        rad_server_dialog: false,

        srcs_headers: [
            { text: 'Source IP', value: 'src', align: 'start' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        auth_server_headers: [
            { text: 'IP', value: 'ip', align: 'start' },
            { text: 'Port', value: 'port', },
            { text: 'Secret', value: 'secret', },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        acct_server_headers: [
            { text: 'IP', value: 'ip', align: 'start' },
            { text: 'Port', value: 'port', },
            { text: 'Secret', value: 'secret', },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
    }),

    created() {
      this.initialize();
    },

    methods: {
        rad_td_class_w_name(class_name, row_ind) {
            if (row_ind % 2 == 1)
                return class_name + " br_rd_odd";
            return class_name;
        },

        rad_td_class(rc, ind, row_ind) {
            let add_class = "";

            if (row_ind % 2 == 1) {
                add_class = " br_rd_odd";
            }

            if (ind === rc.num_rows - 1) {
                return "rc_td_bottom" + add_class;
            }

            return "rc_td_no_borders" + add_class;
        },

        calculate_fields() {
            this.radius.forEach(rc => {
                let l = 1;
                if (rc.srcs.length > l) {
                    l = rc.srcs.length;
                }
                if (rc.auth_servers.length > l) {
                    l = rc.auth_servers.length;
                }
                if (rc.acct_servers.length > l) {
                    l = rc.acct_servers.length;
                }
                rc["num_rows"] = l;
            });
        },

        initialize() {
            return new Promise((resolve, reject) => {
                api_client.sh_radius_clients()
                .then(response => {
                    this.radius = response.data;
                    this.calculate_fields();
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                });
            });
        },

        edit_item(rc) {
            Object.assign(this.edited_rc, rc);
            this.dialog = true;
        },

        delete_item(rc) {
            this.$fire({title: "Notice", text: "The command is not yet implemented.", type: "notice"});
        },

        close() {
            this.dialog = false;
            this.initialize();
        },

        show_rad_client_form() {
            this.rad_client_id = '';
            requestAnimationFrame(() => {
                this.$refs.rad_client_observer.reset();
            });          
            this.rad_client_dialog = true;
        },

        close_rad_client_form() {
            this.rad_client_dialog = false;
        },

        save_rad_client_form() {
            api_client.radius_add_client({
                id: this.rad_client_id
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    /* success */
                    this.close_rad_client_form();
                    this.initialize();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },
        
        show_src_ip_form() {
            this.src_ip = '';
            requestAnimationFrame(() => {
                this.$refs.src_ip_observer.reset();
            });          
            this.src_ip_dialog = true;
        },
        
        close_src_ip_form() {
            this.src_ip_dialog = false;
        },

        on_src_ip_addr_cancel() {
            this.show_src_ip_addr_form = false;
        },

        on_src_ip_addr_select(ip_addr) {
            this.src_ip = ip_addr;
            this.show_src_ip_addr_form = false;
        },

        show_src_ip_addrs_form() {
            this.show_src_ip_addr_form = true;
        },
        
        update_edited_rc() {
            this.radius.forEach(rc => {
                if (rc.id === this.edited_rc.id) {
                    this.edited_rc = Object.assign({}, rc);
                }
            });
        },

        save_src_ip_form() {
            api_client.radius_add_src_ip({
                id: this.edited_rc.id,
                src_ip: this.src_ip
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    /* success */
                    this.edited_rc.srcs.push({src: this.src_ip});
                    this.src_ip_dialog = false;
                    this.initialize().then(value => {
                        this.update_edited_rc();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });        
        },

        add_server(type) {
            this.rad_srv_ip = '';
            this.rad_srv_port = '';
            this.rad_srv_secret = '';
            requestAnimationFrame(() => {
                this.$refs.rad_server_observer.reset();
            });          
            this.rad_server_dialog = true;
            this.rad_srv_type = type;
        },

        add_auth_server() {
            this.add_server('auth');
        },

        add_acct_server() {
            this.add_server('accounting');
        },

        on_rad_server_cancel() {
            this.rad_server_dialog = false;
        },

        on_rad_server_save() {
            let srv = {
                id: this.edited_rc.id,
                type: this.rad_srv_type,
                ip: this.rad_srv_ip,
            };
            if (this.rad_srv_port.trim() != '') {
                srv["port"] = this.rad_srv_port.trim();
            }
            if (this.rad_srv_secret.trim() != '') {
                srv["secret"] = this.rad_srv_secret.trim();
            }

            api_client.radius_add_server(srv)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    /* success */
                    let data_grid_item = {
                        ip: this.rad_srv_ip,
                        port: this.rad_srv_port,
                        secret: this.rad_srv_secret,
                    };
                    if (this.rad_srv_type === 'auth') {
                        this.edited_rc.auth_servers.push(data_grid_item);
                    }
                    else {
                        this.edited_rc.acct_servers.push(data_grid_item);
                    }
                    this.rad_server_dialog = false;
                    this.initialize().then(value => {
                        this.update_edited_rc();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        del_auth_server(item) {
            this.deleted_index = this.edited_rc.auth_servers.indexOf(item);
            Object.assign(this.deleted_item, item);
            this.$confirm("Are you sure you want to delete auth radius server " + 
                item.ip + ":" + item.port + "?")
            .then(() => {
                this.del_server_confirm("auth");
            });
        },

        del_acct_server(item) {
            this.deleted_index = this.edited_rc.acct_servers.indexOf(item);
            Object.assign(this.deleted_item, item);
            this.$confirm("Are you sure you want to delete accounting radius server " + 
                item.ip + ":" + item.port + "?")
            .then(() => {
                this.del_server_confirm("accounting");
            });
        },        

        del_server_confirm(type) {
            let srv = {
                id: this.edited_rc.id,
                type: type,
                ip: this.deleted_item.ip,
            };
            if (typeof this.deleted_item.port === 'number') {
                srv["port"] = this.deleted_item.port;
            }

            api_client.radius_del_server(srv)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                    return;
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
            if (type === 'auth') {
                this.edited_rc.auth_servers.splice(this.deleted_index, 1);
            }
            else {
                this.edited_rc.acct_servers.splice(this.deleted_index, 1);
            }
        },

        save_secrets() {
            let data = {
                id: this.edited_rc.id,
                type: "auth",
                secret: this.edited_rc.auth_secret
            };
            api_client.radius_set_secrets(data)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                    return;
                }
                data = {
                    id: this.edited_rc.id,
                    type: "accounting",
                    secret: this.edited_rc.acct_secret
                };
                api_client.radius_set_secrets(data)
                .then(response => {
                    if (response.data.hasOwnProperty("err_msg")) {
                        this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$fire({title: "Command failed", text: error, type: "warning"});
                });        
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },
    }
};
</script>
